/**
 *
 *  SignUpForm
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 02/03/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";

// Hooks
import useTheme from "../ThemeProvider/useTheme/useTheme";

// Utils
import { isAndroidDevice, isMac, isIosDevice, clientWidth } from "../../utils";

export const PhoneCodeInput = React.forwardRef(
  (
    {
      className,
      inputClassName,
      countryFlag,
      countryShortName,
      phoneCode,
      onClick,
    },
    outerRef
  ) => {
    const { theme } = useTheme();

    return (
      <div
        ref={outerRef}
        className={`${className} tbk-relative tbk-flex tbk-shrink-0 tbk-cursor-pointer tbk-items-center`}
        onClick={onClick}
      >
        <span
          className={`tbk-absolute ${
            phoneCode && phoneCode.length > 3
              ? "tbk-left-1 md:tbk-left-1"
              : "tbk-left-2 md:tbk-left-2"
          } _md:tbk-left-2 tbk-select-none tbk-text-lg md:tbk-text-3xl`}
        >
          {isAndroidDevice || isMac || isIosDevice ? (
            countryFlag
          ) : (
            <img
              src={countryFlag}
              className="tbk-w-3 md:tbk-w-4"
              alt={countryShortName}
            />
          )}
        </span>
        <input
          type="text"
          className={`${inputClassName} tbk-input-field tbk-mb-0 tbk-h-7 ${
            (phoneCode && phoneCode.length > 3) ||
            clientWidth() < theme.responsive.breakpoints.lg
              ? `tbk-text-h3-subtitle ${
                  phoneCode && phoneCode.length > 3
                    ? "tbk-pl-4 md:tbk-pl-5"
                    : "tbk-pl-5 md:tbk-pl-6"
                }`
              : "tbk-text-title-medium tbk-pl-5 md:tbk-pl-6"
          } tbk-w-24 tbk-cursor-pointer tbk-pr-1   md:tbk-w-29`}
          value={phoneCode}
          readOnly
        />
      </div>
    );
  }
);

export default PhoneCodeInput;
